import { render, staticRenderFns } from "./RegraPersonalizada.vue?vue&type=template&id=10e6a321&scoped=true"
import script from "./RegraPersonalizada.vue?vue&type=script&lang=js"
export * from "./RegraPersonalizada.vue?vue&type=script&lang=js"
import style0 from "./RegraPersonalizada.vue?vue&type=style&index=0&id=10e6a321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6a321",
  null
  
)

export default component.exports